import { useEffect } from 'react';
import { useReducer, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { isLoading, logout } from '../store';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

const httpReducer = (curHttpState, action) => {
  switch (action.type) {
    case 'SEND':
      return {
        loading: true,
        error: null,
        data: null,
      };
    case 'RESPONSE':
      return {
        ...curHttpState,
        loading: false,
        data: action.responseData,
      };
    case 'ERROR':
      return { loading: false, error: action.errorMessage };
    case 'CLEAR':
      return initialState;
    default:
      throw new Error('Should not be reached!');
  }
};

const BaseURL = 'http://84.241.57.179/';

const useHttp = () => {
  const [httpState, dispatchHttp] = useReducer(httpReducer, initialState);
  const [shoot, setShoot] = useState(false);
  const dispatch = useDispatch();

  const clear = useCallback(() => dispatchHttp({ type: 'CLEAR' }), []);

  useEffect(() => {
    if (shoot) {
      dispatch(logout());
    }
  });

  const sendRequest = useCallback(
    (url, method, body, header, notjson) => {
      dispatch(isLoading(true));
      dispatchHttp({ type: 'SEND' });

      fetch(BaseURL + url, {
        method: method,
        body: body,
        headers: {
          ...header,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          if (notjson) {
            return response;
          } else {
            return response.json();
          }
        })
        .then((responseData) => {
          dispatch(isLoading(false));
          if (responseData && responseData.code === 'token_not_valid') {
            setShoot(true);
          }
          dispatchHttp({
            type: 'RESPONSE',
            responseData: responseData,
          });
        })
        .catch((error) => {
          console.log(error);
          dispatch(isLoading(false));
          dispatchHttp({
            type: 'ERROR',
            errorMessage: `Something went wrong! -> ${error}`,
          });
        });
    },
    [dispatch]
  );

  return {
    isLoading: httpState.loading,
    data: httpState.data,
    error: httpState.error,
    sendRequest: sendRequest,
    clear: clear,
  };
};

export default useHttp;
